import React, { useState } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import get from 'lodash/get';
import ProfileSettings from '@Services/ProfileSettings';

import { ProfileSettingsConfig } from '@Constants/rx-user/constants';

import BlockHeading from '../../BlockHeading';
import PreferredSuppliers from './Components/PreferredSuppliers';

function PreferencesPreferredSuppliersSection({ editUser, openSupplierPreferences, onChange, onSave, onClose, onReset }) {
  const sectionName = 'PREFERRED_SUPPLIERS';
  const [open, setOpen] = useState(openSupplierPreferences);

  const toggleOpen = () => {
    setOpen(!open);
  };

  const closeCallback = () => setOpen(false);

  const handleClose = () => {
    setOpen(false);
    onClose(sectionName);
  };

  const handleSave = () => {
    onSave(sectionName, closeCallback);
  };

  const handleChange = (name, value) => {
    onChange(['SUPPLIERS', 'RX2_SUPPLIERS', name], value);
  };

  const handleReset = () => {
    onReset(sectionName, [sectionName], closeCallback);
  };
  return (
    <div>
      <BlockHeading title={ProfileSettingsConfig.Labels.supplierPreferences} withResetButton={!open} onResetClick={handleReset} />
      <PreferredSuppliers
        open={open}
        onOpen={toggleOpen}
        optionsMap={get(ProfileSettings.getCombinedInfo(), ['SUPPLIERS', 'preferences', 'RX2_SUPPLIERS', 'preferences'])}
        checkedOptionsMap={get(editUser, ['SUPPLIERS', 'RX2_SUPPLIERS'])}
        onChange={handleChange}
        onClose={handleClose}
        onReset={handleReset}
        onSave={handleSave}
      />
    </div>
  );
}

PreferencesPreferredSuppliersSection.propTypes = {
  editUser: PropTypes.object,
  openSupplierPreferences: PropTypes.bool,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func,
};

PreferencesPreferredSuppliersSection.defaultProps = {
  onChange: noop,
  onSave: noop,
  onClose: noop,
  onReset: noop,
};

export default PreferencesPreferredSuppliersSection;
